module.exports = __webpack_public_path__ + "img/Slice 268@2x(2).8b458315.png";